import HttpClient from "../httpClient";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";
import { CurrentUser } from "../../models/types/user/current-user";
import { UserItem } from "../../models/types/user/user-managerment";
class UserManagementService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<any>): Promise<DefaultResponseContent<UserItem[]>> {
        const response = await this.service.get<DefaultResponseContent<UserItem[]>>("/admin/User/GetUserManagement", requestData);
        return response;
    }

    async getDetailById(id: string): Promise<DefaultResponse<UserItem>> {
        const response = await this.service.get<DefaultResponse<UserItem>>(`/admin/User/GetUserDetail?id=${id}`);
        return response;
    }

    async createUser(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/User/CreateUser`, requestData);
        return response;
    }

    async updateUser(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.put<DefaultResponse<any>>(`/admin/User/UpdateUser`, requestData);
        return response;
    }

    async deleteUser(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/User/DeleteUser/${id}`);
        return response;
    }

    async resetPassword(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.postParams<DefaultResponse<any>>(`/admin/User/ResetPassword`, requestData);
        return response;
    }

    async activeUser(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/User/ActiveUser?id=${id}`);
        return response;
    }

    async deactiveUser(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/User/DeActiveUser?id=${id}`);
        return response;
    }

    async kickOutUser(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/User/KickOutUser?userId=${id}`);
        return response;
    }

    async getAccountDetail(): Promise<DefaultResponse<CurrentUser>> {
        const response = await this.service.get<DefaultResponse<CurrentUser>>(`/Account/GetUserAccountDetail`);
        return response;
    }

    async updateAccount(formData: FormData): Promise<DefaultResponse<any>> {
        const response = await this.service.postBinary<DefaultResponse<any>>(`/Account/UpdateUserAccount`, formData);
        return response;
    }

    async changePassword(requestData: { currentPassword: string, newPassword: string }): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/Account/ChangePassword`, requestData);
        return response;
    }
    async disable2FA(id: string): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/User/Disable2FAUser?id=${id}`);
        return response;
    }

}

const userManagementSvc = new UserManagementService();
export default userManagementSvc;